import { createSlice } from "@reduxjs/toolkit";

const initialUsers = {
    isLoggedIn: false,
    username: "",
    name: "",
    surname: "",
    email: "",
    role: "",
    gender: "",
    token: null,
    phone: "",
    language: (typeof localStorage !== "undefined" && localStorage.getItem("language")) || "geo",
    theme: (typeof localStorage !== "undefined" && localStorage.getItem("theme")) || "light",
    balance: "",
    debt: "",
    id: "",
    identity_number: ""
}

const user = createSlice({
    name: "users",
    initialState: initialUsers,
    reducers: {
        changeIsLoggedIn(state, action){
            state.isLoggedIn = action.payload
        },
        saveUserData(state, action){
            state.balance = action.payload.balance;
            state.email = action.payload.email;
            state.id = action.payload.id;
            state.identity_number = action.payload.identity_number;
            state.last_login_time = action.payload.last_login_time;
            state.last_purchase_date = action.payload.last_purchase_date;
            state.name = action.payload.name;
            state.phone = action.payload.phone;
            state.role = action.payload.role;
            state.signup_date = action.payload.signup_date;
            state.surname = action.payload.surname;
            state.username = action.payload.username;
            state.debt = action.payload.debt;
        },
        setToken(state, action){
            state.token = action.payload;
        },
        setLanguage(state, action){
            state.language = action.payload;
            if(typeof localStorage !== "undefined") localStorage.setItem("language", action.payload);
        },
        setTheme(state, action){
            state.theme = action.payload;
            if(typeof localStorage !== "undefined") localStorage.setItem("theme", action.payload);
            if(typeof document !== "undefined") document.documentElement.setAttribute("data-theme", action.payload);
        }
    }
})

export const usersActions = user.actions;

export default user.reducer